import { type PageStoreState, usePageStore } from '../../_shared/formStore'

import type { CoverFormValues } from '../_types/form'
import type { CoverPrefs, CoverUI } from './index'

type CoverStoreState = PageStoreState<CoverFormValues, CoverPrefs, CoverUI>

/** Cover 页面专用的 store 消费 hook，免去手写泛型参数 */
export function useCoverStore<U>(selector: (state: CoverStoreState) => U): U {
  return usePageStore<CoverFormValues, CoverPrefs, CoverUI, U>(selector)
}
